import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../../UserProvider";
import { useContext, useEffect } from "react";
import { BecomePremiumMember } from "../../components/BecomeAMember";
import { getDayString } from "../../services/utilities";

export function ReplayRoute() {
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const currentString = getDayString();
  const dayString = dayjs(currentString).format("YYYY-MM-DD");

  useEffect(() => {
    if (userDetails?.premiumGames?.includes("emovi")) {
      navigate(`/archive/${dayString}`);
    }
  }, []);

  return (
    <>
      <div className="px-4 md:px-0">
        <div className="mb-4 mt-4">
          <Link to="/">
            <span className="text-blue-500 hover:text-blue-400">
              &#8592; Back
            </span>
          </Link>
        </div>
        <h2 className="text-xl font-bold mb-2">Replay games</h2>
        <>
          <p className="mb-3">
            Replaying games is an exclusive feature for Premium Members.
          </p>
          <div className="flex flex-col gap-2">
            <BecomePremiumMember />
          </div>
        </>
      </div>
    </>
  );
}
